import find from 'lodash/find'
import filter from 'lodash/filter'

const getters = {

  basicProfessions: state => {
    return state.professions ? state.professions : [];
  },
  getProfessionById: state => id => find(state.professions, ['id', id]),
  getProfessionNameById: state => id => {const s = find(state.professions, ['id', id]); return s ? s.name : '';},
  getProfessionIconById: state => id => {const s = find(state.professions, ['id', id]); return s ? s.icon : 'question';},
  hasProfessionOrientations: state => id => {
    const p = find(state.professions, ['id', id])
    return Boolean(p && p.machineOrientations && p.machineOrientations.length>0)
  },

  basicEmploymentTypes: state => {
    return state.employmentTypes ? state.employmentTypes : [];
  },
  getEmploymentTypeById: state => id => find(state.employmentTypes, ['id', id]),
  getEmploymentTypeNameById: state => id => {const s = find(state.employmentTypes, ['id', id]); return s ? s.name : '';},

  basicApplicationStates: state => {
    return state.states ? state.states : [];
  },
  basicStates: state => {return state.states ? state.states : []},
  getStateById: state => id => find(state.states, ['id', id]),
  getStateNameById: state => id => {const s = find(state.states, ['id', id]); return s ? s.name : '';},
  getStateByStatename: state => statename => find(state.states, ['state', statename]),
  confirmedAndApprovedByCompany: state => {
    if (!state.states)
      return -1
    const foundStates = filter(state.states, {state: 'confirmedAndApprovedByCompany'})
    return foundStates && foundStates.length ? foundStates.map(o => {return o.id}) : []
  },
  getApprovedApplications: state => {
    if (!state.states)
      return -1
    const foundStates = filter(state.states, {state: 'approved'})
    return foundStates && foundStates.length ? foundStates.map(o => {return o.id}) : []
  },
  approvedByByn: state => {
    if (!state.states)
      return -1
    const foundStates = filter(state.states, {state: 'approved'})
    return foundStates && foundStates.length ? foundStates.map(o => {return o.id}) : []
  },
  getOrderedApplication: state => {
    if (!state.states)
      return -1
    const foundStates = filter(state.states, {state: 'ordered'})
    return foundStates && foundStates.length ? foundStates.map(o => {return o.id}) : []
  },
  approvedState: state => {
    if (!state.states)
      return {id: -1}
    return find(state.states, {state: 'approved'})
  },
  orderedState: state => {
    if (!state.states)
      return {id: -1}
    return find(state.states, {state: 'ordered'})
  },

  guIssuedState: state => {
    if (!state.states)
      return {id: -1}
    return find(state.states, {state: 'basicEducationCertificateIssued'})
  },

  closedState: state => {
    if (!state.states)
      return {id: -1}
    return find(state.states, {state: 'closed'})
  },
  basicRegions: state => {
    return state.regions ? state.regions : [];
  },
  getRegionById: state => id => find(state.regions, ['id', id]),
  getRegionNameById: state => id => {const s = find(state.regions, ['id', id]); return s ? s.name : '';},
  basicMachines: state => {
    return state.machines ? state.machines : [];
  },
  activeMachines: state => {
    return filter(state.machines, ['isActive', true]);
  },
  getMachineNameById: state => id => {const s = find(state.machines, ['id', id]); return s ? s.name : '';},
  basicDistanceOrderStates: state => {
    return state.distanceOrderStates ? state.distanceOrderStates : [];
  },
  basicExtensionOrderStates: state => {
    return state.extensionOrderStates ? state.extensionOrderStates : [];
  },

  approvedDistanceOrderState: state => {
    if (!state.distanceOrderStates)
      return {id: -1}
    return find(state.distanceOrderStates , {state: 'approvedByCompany'})
  },

  orderedDistanceOrderState: state => {
    if (!state.distanceOrderStates)
      return {id: -1}
    return find(state.distanceOrderStates , {state: 'commissioned'})
  },

  basicPrintOrderStates: state => {
    return state.printOrderStates ? state.printOrderStates : [];
  },
  getQualificationLengthItems: state => {
    let timesLengths = [
      {id: 0, text: '0 månader', value: 0},
      {id: 1, text: '1 månad', value: 1}
    ]
    for (let i = 2; i < 37; i++) {
      timesLengths.push({id: i, text: i + ' månader', value: i})
    }
    return timesLengths
  },
  systemSettings: state => {
    return state.systemSettings ? state.systemSettings : {};
  }

};

export default getters;
